import * as React from 'react';
import {
	makeStyles,
	Box,
	Menu,
	MenuItem,
	Typography,
	Fab,
	Dialog,
	DialogTitle,
	Button,
	DialogContentText,
	DialogActions,
	DialogContent,
} from '@material-ui/core';
import { stores } from '../../store';
import { observer } from 'mobx-react-lite';
import { faCog, faInfoCircle, faUser, faSignOut } from '@fortawesome/pro-light-svg-icons';
import { Icon } from '@mitie/material-ui-extensions';
import { faUserCog as faUserCogSolid } from '@fortawesome/pro-solid-svg-icons';

const useStyles = makeStyles(theme => ({
	accountIcon: {
		width: '40px',
		height: '40px',
		boxShadow: 'none',
		'&:focus-visible': {
			outline: '2px solid #002855',
			boxShadow: 'none !important',
		},
		'@media(max-width:1024px)': {
			width: '24px',
			height: '24px',
			minHeight: '24px',
			'& svg': {
				height: '11.2px',
				width: '11.2px !important',
			},
		},
		'& .fa-user-cog': {
			color: theme.palette.background.paper,
			display: 'flex',
		},
	},
	alignStyle: {
		padding: '16px 0px !important',
	},
	listicon: {
		margin: theme.spacing(0, 1, 0.375, 0),
		'@media(max-width:1024px)': {
			'& svg': {
				height: '11.2px',
				width: '11.2px !important',
			},
		},
	},
}));

const UserAccountIcon = observer(() => {
	const user = React.useContext(stores.context.user);
	const routes = React.useContext(stores.context.routes);
	const classes = useStyles();
	const [esmeDialogOpen, setEsmeDialogOpen] = React.useState(false);
	const [esmeDialogOpennew, setEsmeDialogOpennew] = React.useState(false);
	const [rotName, setRoutName] = React.useState('');

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const dialogfn = (val: any) => {
		setRoutName(val);
		if (routes.testval === true && window.location.pathname === '/ask/chatbot') {
			setEsmeDialogOpen(true);
		} else if (routes.viewmyjobval === true && window.location.pathname === '/ask/view-my-jobs') {
			setEsmeDialogOpen(true);
		} else {
			routes.navigate(
				{ name: val },
				{
					clearParams: true,
				},
			);
		}
	};

	const dialogfnnew = () => {
		if (routes.testval === true && window.location.pathname === '/ask/chatbot') {
			setEsmeDialogOpennew(true);
		} else if (routes.viewmyjobval === true && window.location.pathname === '/ask/view-my-jobs') {
			setEsmeDialogOpennew(true);
		} else {
			user.logout();
			handleClose();
		}
	};

	const handleClickClose = () => {
		setEsmeDialogOpen(false);
	};

	const handleCloseChat = () => {
		// inform Esme before navigation
		resetChatbot();
		// dela 0.5 second so Esme if in Live chat can inform Mitel agent about user leaving chat
		setTimeout(() => {
			routes.testval = false;
			routes.viewmyjobval = false;
			setEsmeDialogOpen(false);
			routes.navigate(
				{ name: rotName },
				{
					clearParams: true,
				},
			);
		}, 500);
	};

	const resetChatbot = () => {
		const iframeEl: any = document.getElementById('myframe');
		iframeEl.contentWindow.postMessage('reset', '*');
	};

	const handleClickClosenew = () => {
		setEsmeDialogOpennew(false);
	};

	const handleCloseChatnew = () => {
		routes.testval = false;
		routes.viewmyjobval = false;
		setEsmeDialogOpennew(false);
		user.logout();
	};

	return (
		<>
			<Box>
				<Fab
					role="button"
					aria-label="User Settings"
					title="User Settings"
					onClick={handleClick}
					color="primary"
					className={classes.accountIcon}
				>
					<Icon icon={faUserCogSolid} />
				</Fab>
				{user.isUserLoggedIn && (
					<Menu
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={handleClose}
						elevation={3}
						getContentAnchorEl={null}
						anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
						transformOrigin={{ vertical: 'top', horizontal: 'right' }}
						className="menu-class"
					>
						<MenuItem
							role="link"
							onClick={() => {
								dialogfn('profile');
							}}
						>
							<Icon icon={faUser} className={classes.listicon} />
							<Typography variant="inherit">Profile</Typography>
						</MenuItem>

						<MenuItem
							role="link"
							onClick={() => {
								dialogfn('settings');
							}}
						>
							<Icon icon={faCog} className={classes.listicon} />
							<Typography variant="inherit">Settings</Typography>
						</MenuItem>

						<MenuItem
							role="link"
							onClick={() => {
								dialogfn('about');
							}}
						>
							<Icon icon={faInfoCircle} className={classes.listicon} />
							<Typography variant="inherit">About</Typography>
						</MenuItem>

						<MenuItem
							role="link"
							onClick={() => {
								dialogfnnew();
							}}
						>
							<Icon icon={faSignOut} className={classes.listicon} />
							<Typography variant="inherit">Logout</Typography>
						</MenuItem>
					</Menu>
				)}
			</Box>
			<Dialog style={{ margin: 'auto', maxWidth: '375px' }} open={esmeDialogOpen} onClose={handleClickClose}>
				<DialogContent>
					<DialogTitle id="form-dialog-title" className={classes.alignStyle}>
						Are you sure you want to leave the chat
					</DialogTitle>
					<DialogContentText>
						Please take a note of the Service Request reference if given, this chat will end and be deleted.
					</DialogContentText>
					<DialogActions>
						<Button onClick={handleCloseChat} title="Close chat" color="primary">
							Close chat
						</Button>
						<Button onClick={handleClickClose} title="Return to chat" color="primary">
							Return to chat
						</Button>
					</DialogActions>
				</DialogContent>
			</Dialog>

			<Dialog style={{ margin: 'auto', maxWidth: '375px' }} open={esmeDialogOpennew} onClose={handleClickClosenew}>
				<DialogContent>
					<DialogTitle id="form-dialog-title" className={classes.alignStyle}>
						Are you sure you want to leave the chat
					</DialogTitle>
					<DialogContentText>
						Please take a note of the Service Request reference if given, this chat will end and be deleted.
					</DialogContentText>
					<DialogActions>
						<Button onClick={handleCloseChatnew} title="Close chat" color="primary">
							Close chat
						</Button>
						<Button onClick={handleClickClosenew} title="Return to chat" color="primary">
							Return to chat
						</Button>
					</DialogActions>
				</DialogContent>
			</Dialog>
		</>
	);
});

export default UserAccountIcon;
